import axios from 'axios';

import { DeviceInterceptor, DeviceService } from '../../external/device';
import { storage } from '../storage/storage.service';

const deviceService = new DeviceService(storage, axios);
const deviceInterceptor = new DeviceInterceptor(axios, deviceService);

deviceInterceptor.startIntercepting();
void deviceService.register();

export default deviceService;
